import { CustomerSettingName, CustomerSettingValue } from './mijn-klantinstellingen.model';

export class MijnKlantinstellingenMapper {
    public static map<T extends CustomerSettingName>(settingName: T, value: CustomerSettingValue<T>): CustomerSettingValue<T> {
        if (settingName === CustomerSettingName.MIJN_REKENING_FIRST_TIME_USE_TOUR) {
            return MijnKlantinstellingenMapper.mapMijnRekeningFirstTimeUse(value as unknown) as CustomerSettingValue<T>;
        }
        return value;
    }

    private static mapMijnRekeningFirstTimeUse(
        value: unknown
    ): CustomerSettingValue<CustomerSettingName.MIJN_REKENING_FIRST_TIME_USE_TOUR> {
        if (value === false) {
            return '1970-01-01';
        }
        if (value === true) {
            return '2021-12-01';
        }

        return value as string;
    }
}
